// The refresh credential on the web (FR-019; research R3): the browser holds it as the HttpOnly
// akv_rt_app cookie, set and cleared by the server only. Nothing to store or send here.
export const refreshCredential = {
  async read(): Promise<string | null> {
    return null;
  },
  async write(_token: string): Promise<void> {},
  async clear(): Promise<void> {},
  async refreshBody(): Promise<{ refreshToken: string } | undefined> {
    return undefined;
  },
};
